export const USER_LOADED = 'USER_LOADED'
export const LOGOUT = 'LOGOUT'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const SET_COMPANY_NAME = 'SET_COMPANY_NAME'
